export const getNameFromToken = (token: string) => {
  try {
    const data = JSON.parse(atob(token.split(".")[1]));
    return data["https://firebolt.io/claims"]?.organization_name;
  } catch (e) {
    return null;
  }
};
